// extracted by mini-css-extract-plugin
export default {"modal-content":"styles_modal-content__NKeDG","modal-content-simple-review":"styles_modal-content-simple-review__6O8QP","modal-dialog":"styles_modal-dialog__IMXxJ"};